import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Approach } from './components/Approach';
import { Ventures } from './components/Ventures';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
function HomePage() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-orange selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Approach data-id="element-4" />
        <Ventures data-id="element-5" />
        <Contact data-id="element-6" />
      </main>

      <Footer data-id="element-7" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-8">
      <Routes data-id="element-9">
        <Route path="/" element={<HomePage data-id="element-11" />} data-id="element-10" />
        <Route path="/privacy" element={<Privacy data-id="element-13" />} data-id="element-12" />
        <Route path="/terms" element={<Terms data-id="element-15" />} data-id="element-14" />
      </Routes>
    </BrowserRouter>;
}